import React from 'react'
import './About.scss'
import {
  Col,
  Container,
  Row
} from 'reactstrap'

function About() {
  return (
    <Container fluid className="About pb-5 d-flex flex-column align-items-center">
      <article className="pt-5 px-4 pt-md-0">
        <Row className="align-items-lg-center">
          <Col xs={12} md={6}>
            <img className="rounded-lg w-100" src="images/author-picture-castillo.jpg" alt="Jane Hartenstein"/>
          </Col>
          <Col>
            <p className="mt-4 sm:mt-0">
              Jane’s latest book <u>An Epidemic Of Glory</u>, explores Spain’s early attempts at colonization and the
              ill-fated Tristan de Luna expedition’s attempt to settle what is now Pensacola. The lessons learned will
              pave the way for St. Augustine and change the path of history.
            </p>
            <p >
              A resident of St. Augustine, Florida, Jane Hartenstein celebrates the unique history of St. Augustine from
              17th century etiquette to the transfer of Florida from Spain to the United States as yellow fever
              threatens to the gilded age fascination with taking the waters.</p>
            <p>
              Jane has also combined her love of history with her thirty years of experience in mental health to author
              the <em>VOICES</em> series of historical fiction novels follow the lives of people who hear voices and the
              laws, medicine, and superstitions that impact them.</p>
            <p>
              Jane has written and produced two documentary films for the North Creek Depot Museum in North Creek, New
              York; <em>Teddy Roosevelt; Ride to Destiny</em> and <em>Dr. Thomas Durant; Railroad Pioneer</em>.</p>
            <p>
              A member of the Florida Writers Association and the Mental Health Writers Association, she can be found
              speaking on colonial field surgery at the Castillo San Marco National Park or explaining the use of 19th
              century water treatments at the Lightner Museum in St. Augustine, Florida.</p>
          </Col>
        </Row>

      </article>
      <div className="text-center writers-guild">
        <img className="img-fluid w-75" src="/images/mhwg_logo-2.png" alt="mental health writers guild"/>
      </div>
    </Container>
  )
}

export default About
